import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["range", "tipFormatter"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import Slider from './Slider';
import Range from './Range';
import Handle from './Handle';
import createSliderWithTooltip from './createSliderWithTooltip'; // Slider.Range = Range;
// Slider.Handle = Handle;
// Slider.createSliderWithTooltip = createSliderWithTooltip;

var SliderRangeTooltip = createSliderWithTooltip(Range);
var SliderTooltip = createSliderWithTooltip(Slider);

var SliderComponents = /*#__PURE__*/function (_React$Component) {
  _inherits(SliderComponents, _React$Component);

  var _super = _createSuper(SliderComponents);

  function SliderComponents() {
    _classCallCheck(this, SliderComponents);

    return _super.apply(this, arguments);
  }

  _createClass(SliderComponents, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          range = _this$props.range,
          tipFormatter = _this$props.tipFormatter,
          others = _objectWithoutProperties(_this$props, _excluded);

      if (this.props && this.props.hasOwnProperty('range') && range && this.props.hasOwnProperty('tipFormatter')) {
        return /*#__PURE__*/React.createElement(SliderRangeTooltip, _extends({
          range: true,
          tipFormatter: tipFormatter
        }, others));
      } else if (this.props && this.props.hasOwnProperty('range') && range) {
        return /*#__PURE__*/React.createElement(Range, _extends({
          range: true
        }, others));
      } else if (this.props && this.props.hasOwnProperty('tipFormatter')) {
        return /*#__PURE__*/React.createElement(SliderTooltip, _extends({
          tipFormatter: tipFormatter
        }, others));
      } else {
        return /*#__PURE__*/React.createElement(Slider, others);
      }
    }
  }]);

  return SliderComponents;
}(React.Component);

SliderComponents.Range = Range;
SliderComponents.Handle = Handle;
SliderComponents.createSliderWithTooltip = createSliderWithTooltip;
export default SliderComponents;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-slider/src/index.js